'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var icon = {
        display: 'inline-block',
        width: '30px',
        height: '20px',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        marginLeft: theme.gutter + 'px',
        flexShrink: 0
    };

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            color: theme.color,
            fontWeight: theme.fontWeight,
            display: 'flex',
            width: theme.width,
            minWidth: theme.minWidth,
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        balance: {
            color: theme.balanceColor,
            fontWeight: theme.balanceFontWeight,
            marginRight: theme.gutter / 2 + 'px'
        },
        name: {
            color: theme.nameColor,
            fontWeight: theme.nameFontWeight,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        number: {
            color: theme.numberColor,
            fontWeight: theme.numberFontWeight,
            marginRight: theme.gutter + 'px'
        },
        currency: {
            color: theme.currencyColor,
            fontWeight: theme.currencyFontWeight,
            marginRight: theme.gutter + 'px'
        },
        visa: Object.assign({}, icon, {
            backgroundImage: 'url("' + _visa2.default + '")'
        }),
        mc: Object.assign({}, icon, {
            backgroundImage: 'url("' + _mc2.default + '")'
        }),
        iconWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
        },
        textWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: 'calc(100% - ' + (30 + theme.gutter) + 'px)',
            overflow: 'hidden'
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        balance: (0, _aphroditeJss.css)(styleList.balance),
        name: (0, _aphroditeJss.css)(styleList.name),
        currency: (0, _aphroditeJss.css)(styleList.currency),
        visa: (0, _aphroditeJss.css)(styleList.visa),
        mc: (0, _aphroditeJss.css)(styleList.mc),
        number: (0, _aphroditeJss.css)(styleList.number),
        iconWrapper: (0, _aphroditeJss.css)(styleList.iconWrapper),
        textWrapper: (0, _aphroditeJss.css)(styleList.textWrapper)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _visa = require('../img/visa.svg');

var _visa2 = _interopRequireDefault(_visa);

var _mc = require('../img/mc.svg');

var _mc2 = _interopRequireDefault(_mc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        fontSize: theme.tsNormal,
        lineHeight: theme.tlNormal,
        color: theme.tFilled,
        fontWeight: theme.twNormal,

        balanceColor: theme.tFilled,
        balanceFontWeight: theme.twSemi,

        numberColor: theme.tInactive,
        numberFontWeight: theme.twNormal,

        nameColor: theme.tFilled,
        nameFontWeight: theme.twNormal,

        currencyColor: theme.tFilled,
        currencyFontWeight: theme.twSemi,
        width: 'auto',
        minWidth: 'auto'
    };
};